import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import utf8 from 'utf8';
import { PacientService } from 'src/services/pacient.service';
import { Organization } from 'src/models/organization.model';
import { Practicioner } from 'src/models/practicioner.model';
import { Util } from '../../../util/util';

@Component({
    selector: 'list-itens-component',
    templateUrl: 'list-itens-component.html',
    styleUrls: ['./list-itens-component.scss']
})

export class ListItensComponent implements OnInit {
    @Input() classCSS: string;

    @Input() historico: any = {};
    @Input() searchQuery: any = {};
    @Input() nextUrl: any;
    @Input() user: any;

    @Output() onDetalheAtendinento = new EventEmitter();
    @Output() onLoadData = new EventEmitter();

    constructor(private pacient: PacientService,
                private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        if (this.historico.length) {
            this.historico.forEach(element => {
                this.loadInfoOrg(element.organizationRef, element);
                this.loadInfoProf(element.practicionerRoleRef, element);
            });
        }
    }

    getTextFormat(text) {
        return Util.getTextFormat(text);
    }

    detalheAtendinento(item) {
        this.onDetalheAtendinento.emit({
            atendimento: item
        });
    }

    async loadInfoOrg(reference, item) {
        if (reference) {
            const orgData = await this.pacient.getRead(reference);
            if (orgData) {
                item.organization = new Organization(orgData);
                item.estabelecimento = item.organization.nome;
            }
        }
    }

    async loadInfoProf(reference, item) {
        if (reference) {
            const practicionerRole = await this.pacient.getRead(reference);
            if (practicionerRole && practicionerRole.practitioner) {
                const practData = await this.pacient.getRead(practicionerRole.practitioner.reference);
                if (practData) {
                    item.practicioner = new Practicioner(practData);
                    item.profissional = item.practicioner.nome;
                }
            }
        }
    }
}
